import { useGet, useQueryWithErrorHandling } from '@app/sdk';
import { BrandHistory } from '@app/models';
import { brandBaseUrl } from '../BaseUrls';

const pillarCode = "tms";

export function useGetBrandHistory({ id }: { id: string }) {
  const get = useGet(true, pillarCode);
  return useQueryWithErrorHandling({
    queryKey: ['get-brand-history', id],
    queryFn: async () => await get<BrandHistory>(`${brandBaseUrl}/brands/${id}/history`),
    enabled: !!id,
  });
}